/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2023 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * A Modal that handles Aria Beta Users after expiration.
 *
 * @author Deepa Vaidya
 */

import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import PropTypes from 'prop-types';
import {
  withStyles, withTheme, Typography, Dialog,
  DialogContent, Link
} from '@material-ui/core';
import { inject } from 'mobx-react';
import * as shapes from '../shapes';
import Framework from '../../framework/Framework';

const styles = (theme) => ({
  dialogPaperRoot: {
    borderRadius: 16,
    [theme.breakpoints.down(767)]: {
      borderRadius: 0
    }
  },
  dialogContent: {
    paddingTop: 0
  },
  dialogContainer: {
    maxWidth: 720,
    padding: '0px 54px 20px 54px',
    textAlign: 'center',
    [theme.breakpoints.down(767)]: {
      minWidth: 'fit-content',
      paddingTop: 100
    }
  },
  subtitle: {
    fontSize: '14px',
    letterSpacing: 0.02,
    lineHeight: '24px',
    fontFamily: 'TT Commons'
  }
});
const OzBetaEnded = (
  {
    language, classes, langKeyPrefix
  }
) => (
  <Dialog
    open
    maxWidth="md"
    scroll="paper"
    id="dialog-popup"
    aria-labelledby="dialog-popup-title"
    aria-describedby="dialog-popup-content"
    classes={{ paper: classes.dialogPaperRoot }}
  >
    <DialogContent
      id="dialog-popup-content"
      className={classes.dialogContent}
    >
      <div className={classes.dialogContainer}>
        <Typography className={classes.subtitle}>
          <FormattedHTMLMessage
            {...language.getText(`${langKeyPrefix}.BETA_ENDED_DESC`)}
          />
          <Link
            id="login"
            href="false"
            component="button"
            underline="none"
            target="_blank"
            onClick={() => Framework.logout()}
          >
            <FormattedHTMLMessage
              {...language.getText('common.LOGOUT')}
            />
          </Link>
        </Typography>
      </div>
    </DialogContent>
  </Dialog>
);
OzBetaEnded.propTypes = {
  language: shapes.language.isRequired,
  langKeyPrefix: PropTypes.string,
  classes: PropTypes.object.isRequired
};
OzBetaEnded.defaultProps = {
  langKeyPrefix: 'errors'
};
export default withTheme(withStyles(styles)(inject('language')(OzBetaEnded)));
